import React from 'react';
import { Link } from 'react-router-dom';

// Footer.css is kept so any global rules defined there still apply; the
// footer itself is styled by the .mrf-footer block in common/styles/refresh.css.
import "./Footer.css";

import MYREDFOLDER from "../../../../assets/MyRedFolderLogo.png";
import TrustedSite from "../../../../assets/trusted-site@2x.png";
import MCAFEE from "../../../../assets/mcafee secure logo@2x.png";
import email from "../../../../assets/icons/email-contact-icon.svg";
import phone from "../../../../assets/icons/phone-icon.svg";
import location from "../../../../assets/icons/location-icon.svg";

const ADDRESS = "255 Primera Blvd. Ste, 160 Lake Mary, FL 32746";
const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS)}`;

const columns = [
  {
    title: "MYREDFOLDER",
    links: [
      { text: "About Us", path: "/aboutUs/our-history" },
      { text: "Pricing", path: "/pricing" },
      { text: "Contact Us", path: "/aboutUs/contact-us" },
    ],
  },
  {
    title: "Our Services",
    links: [
      { text: "MYREDFOLDER® App", path: "/ourServices/my-mrf-app" },
      { text: "MYREDFOLDER® Plan", path: "/ourServices/my-mrf-plan" },
      { text: "Go Kits / Supply Kits", path: "/ourServices/supply-kits" },
    ],
  },
  {
    title: "Knowledge Base",
    links: [
      { text: "Disaster Resource Library", path: "/knowledgeBase/risk-by-location" },
      { text: "Blog", path: "/knowledgeBase/blog" },
      { text: "FAQ", path: "/knowledgeBase/faq" },
      { text: "MYREDFOLDER® Tribe", path: "/knowledgeBase/myredfolder-tribe" },
    ],
  },
];

const legalLinks = [
  { text: "FAQ", path: "/knowledgeBase/faq" },
  { text: "Security", path: "/security" },
  { text: "Privacy Policy", path: "/privacy-policy" },
];

const Footer = () => (
  <footer className="mrf-footer">
    <div className="mrf-container">
      <div className="mrf-footer__main">
        <div className="mrf-footer__brand">
          <Link to="/" aria-label="MYREDFOLDER® home" className="mrf-footer__logo">
            <img src={MYREDFOLDER} alt="MYREDFOLDER®" />
          </Link>
          <ul className="mrf-footer__contact">
            <li>
              <img src={location} alt="" aria-hidden="true" />
              <a href={MAPS_URL} target="_blank" rel="noreferrer">
                {ADDRESS}
                <span className="visually-hidden"> (opens map in a new tab)</span>
              </a>
            </li>
            <li>
              <img src={phone} alt="" aria-hidden="true" />
              <a href="tel:+18882679990">+ (888) 267 9990</a>
            </li>
            <li>
              <img src={email} alt="" aria-hidden="true" />
              <a href="mailto:info@nepta.us">info@nepta.us</a>
            </li>
          </ul>
        </div>

        {columns.map((column, index) => (
          <nav key={column.title} className="mrf-footer__col" aria-labelledby={`footer-col-${index}`}>
            <h2 id={`footer-col-${index}`} className="mrf-footer__heading">{column.title}</h2>
            <ul className="mrf-footer__links">
              {column.links.map((link) => (
                <li key={link.path}>
                  <Link className="mrf-footer__link" to={link.path}>{link.text}</Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <div className="mrf-footer__trust">
        <p className="mrf-footer__roles">
          <strong>MYREDFOLDER®</strong> is offered by MYREDFOLDER, Inc. and administered by the{" "}
          National Emergency Planning and Training Association (NEPTA).
        </p>
        <div className="mrf-footer__badges">
          <img src={TrustedSite} alt="TrustedSite certified secure" />
          <img src={MCAFEE} alt="McAfee Secure" />
        </div>
      </div>
    </div>

    <div className="mrf-footer__legal">
      <div className="mrf-container mrf-footer__legal-inner">
        <ul className="mrf-footer__legal-links">
          {legalLinks.map((link) => (
            <li key={link.path}>
              <Link to={link.path}>{link.text}</Link>
            </li>
          ))}
        </ul>
        <p className="mrf-footer__copy">© {new Date().getFullYear()} MYREDFOLDER, Inc. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
